import { useCallback, useState } from 'react'

export function useDataObject<T>(initialData: T): [T, (partialData: Partial<T>) => void] {
  const [data, setData] = useState<T>(initialData)
  const updateData = useCallback((partialData: Partial<T>) => {
    setData((prevData) => ({ ...prevData, ...partialData }))
  }, [])
  return [data, updateData]
}
